import React from 'react'

import FormSubsection from 'components/FormSubsection'
import { FieldKit } from 'containers/FormBuilder'
import { FormikValues } from 'formik'

import DisclosureMarineMessageCheckbox from '../DisclosureMarineCheckbox'
import { Row } from '../MarineWriteIn.styled'
import PrimaryResidenceCheckbox from '../ResidenceCheckbox'
import HullCollateralForm from './HullCollateralForm'

interface Props {
    formik: FieldKit<FormikValues>
    prefilled?: boolean
}

function HullFormSubsection({ formik, prefilled }: Readonly<Props>) {
    const fieldProps = {
        formik,
        prefilled,
    }

    return (
        <FormSubsection title="Hull Details">
            <HullCollateralForm {...fieldProps} />
            <Row gridTemplateColumns="1fr">
                <PrimaryResidenceCheckbox {...fieldProps} />
                <DisclosureMarineMessageCheckbox {...fieldProps} />
            </Row>
        </FormSubsection>
    )
}

export default HullFormSubsection
